import * as THREE from 'three';
import { Object3D, PointLight, Raycaster, Vector3 } from 'three';
// import 'typeface-Nunito';
import * as packageInfo from '../../package.json';
import VersionViewer from './utils/VersionViewer';
import { LevelManager, ResourcesManager, ResourceType, Viewer } from '@verybigthings/vbt-webvr-framework';
import { config } from './config';
import EnvironmentLoader from './components/EnvironmentLoader';
import Lobby from './scenario/Lobby';
import Preloader from './components/Preloader';
import Background from './components/Background';
import PPELevel from './scenario/PPELevel';
import { MaterialImprovement } from './utils/MaterialImprovement';
import { SessionController } from '@verybigthings/cerify-ed-simulation--backend-connect';
import DetermineZSpaceDevice from './components/DetermineZSpaceDevice';
import { ZSpacePickingController } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/zSpace_controls/ZSpacePickingController';
SessionController.salt = SECRET_SALT;
window['THREE'] = THREE;
export default class App {
    constructor() {
        this.muted = false;
        // window['quality'] = localStorage.getItem('ZSpaceDeviceType') === 'laptop' ? 'very low' : 'normal';
        // window['quality'] = localStorage.getItem('ZSpaceDeviceType') ? 'very low' : 'normal';
        // window['quality'] = 'very low';
        window.onload = () => {
            this.init();
            window['scene'] = Viewer.scene;
        };
        const isZSpaceLaptop = window['quality'] === 'very low';
        this.texturesFolder = isZSpaceLaptop ? 'textures_low' : 'textures';
        this.modelsFolder = isZSpaceLaptop ? 'models_low' : 'models';
        const requiredAssests = [
            require('../assets/textures_low/environmet/room_texture.jpg'),
            require('../assets/textures/environmet/room_texture.jpg'),
            require('../assets/textures_low/popups/header_short.png'),
            require('../assets/textures/popups/header_short.png'),
            require('../assets/textures_low/petri/clock.png'),
            require('../assets/textures/petri/clock.png'),
            require('../assets/textures_low/logo.png'),
            require('../assets/textures/logo.png'),
        ]; // Just for webpack
        ResourcesManager.addLoadResources([
            {
                name: 'female',
                url: require('../assets/models/female.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            {
                name: 'logo_image',
                url: require(`../assets/${this.texturesFolder}/logo.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'corner',
                url: require('../assets/textures/popups/corner.png'),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'MAP_clock_body',
                url: require(`../assets/${this.texturesFolder}/petri/clock.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
            {
                name: 'main_theme',
                url: require('../assets/sounds/main_theme.mp3'),
                type: ResourceType.AUDIO,
                priority: 0,
            },
            {
                name: 'fail_sound',
                url: require('../assets/sounds/fail_sound.mp3'),
                type: ResourceType.AUDIO,
                priority: 0,
            },
            {
                name: 'background',
                url: require(`../assets/${this.texturesFolder}/environmet/room_texture.jpg`),
                type: ResourceType.TEXTURE,
                priority: 0,
            },
            {
                name: 'FontAwesome&woff2-900-normal',
                url: require('@verybigthings/fontawesome-pro/webfonts/fa-solid-900.woff2'),
                priority: 0,
                type: ResourceType.FONT
            },
            {
                name: 'FontAwesome&woff2-400-normal',
                url: require('@verybigthings/fontawesome-pro/webfonts/fa-regular-400.woff2'),
                priority: 0,
                type: ResourceType.FONT
            },
            {
                name: 'Nunito&woff2-400-normal',
                type: ResourceType.FONT,
                priority: 0,
                url: require('typeface-nunito/files/nunito-latin-400.woff2')
            },
            {
                name: 'Nunito&woff2-600-normal',
                type: ResourceType.FONT,
                priority: 0,
                url: require('typeface-nunito/files/nunito-latin-600.woff2')
            },
            {
                name: 'Nunito&woff2-700-normal',
                type: ResourceType.FONT,
                priority: 0,
                url: require('typeface-nunito/files/nunito-latin-700.woff2')
            },
            {
                name: 'Nunito&woff2-800-normal',
                type: ResourceType.FONT,
                priority: 0,
                url: require('typeface-nunito/files/nunito-latin-800.woff2')
            },
            {
                name: 'Nunito-Sans&woff2-700-normal',
                type: ResourceType.FONT,
                priority: 0,
                url: require('typeface-nunito-sans/files/nunito-sans-latin-700.woff2')
            },
            {
                name: 'popup_decoration_short',
                url: require(`../assets/${this.texturesFolder}/popups/header_short.png`),
                priority: 0,
                type: ResourceType.TEXTURE
            },
        ]);
        // if (this.texturesFolder === 'textures') {
        if (window['quality'] !== 'very low') {
            ResourcesManager.addLoadResources([
                {
                    name: 'table_low_DefaultMaterial_BaseColor',
                    url: require('../assets/textures/table_low_DefaultMaterial_BaseColor.png'),
                    priority: 0,
                    type: ResourceType.TEXTURE
                },
            ]);
        }
    }
    init() {
        const versionViewer = new VersionViewer(packageInfo.version);
        versionViewer.init();
        Viewer.init(config);
        if (Viewer.zSpace)
            Viewer.zSpace.onChangeValidator = () => false;
        Background.setBackground();
        this.pointerController = Viewer.pointerController;
        this.determineZSpaceDevice = new DetermineZSpaceDevice();
        this.lobby = new Lobby(this, envConfig);
        this.ppe = new PPELevel(this);
        this.preloader = new Preloader({
            text: 'LOADING',
            color: '#054360',
            position: new Vector3(0, 0, -8)
        });
        this.preloader.init();
        const scenarios = [
            {
                instance: this.ppe,
                routerLink: '#Ppe',
                name: 'ppe',
                showPreloader: true,
                events: { 'level_done': 'lobby' },
            },
            {
                instance: this.lobby,
                routerLink: '#Lobby',
                name: 'lobby',
                showPreloader: true,
                events: {},
            },
        ];
        let callback1;
        // ResourcesManager.on('load', callback1 = () => {
        //     ResourcesManager.off('load', callback1);
        //     this.initMainTheme();
        // });
        const levelManagerOptions = {
            name: 'Biotech',
            scenarios: scenarios,
            preloader: this.preloader,
            preloaderCamera: true
        };
        let callback2;
        ResourcesManager.on('load', callback2 = () => {
            ResourcesManager.off('load', callback2);
            const environment = new EnvironmentLoader();
            // this.determineZSpaceDevice = new DetermineZSpaceDevice();
            Viewer.scene.add(this.room = environment.generateEnv(ResourcesManager.getTexture('background')));
            MaterialImprovement.init();
            // @ts-ignore
            Viewer.scene.getObjectByName('HemisphereLight').intensity = 0.7;
            // @ts-ignore
            Viewer.scene.getObjectByName('HemisphereLight').groundColor.set(0xbbbbbb);
            // @ts-ignore
            Viewer.scene.children[2].intensity = 1;
            const pointLight = new PointLight(0xffffff, 0.55, 100);
            pointLight.name = 'PointLight';
            pointLight.position.set(0, 12, 0);
            const wrapShpere = new Object3D();
            Viewer.on('goToVR', () => Viewer.hemisphereLight.intensity = 0.45);
            Viewer.on('goFromVR', () => Viewer.hemisphereLight.intensity = 0.7);
            Viewer.on('update', () => {
                wrapShpere.position.copy(Viewer.camera.position);
            });
            wrapShpere.add(pointLight);
            Viewer.scene.add(wrapShpere);
        });
        this.levelManager = new LevelManager(levelManagerOptions);
        this.wrapScreenUI = new Object3D();
        this.wrapScreenUI.position.set(0, 0, 20);
        Viewer.cameraWrapParent.add(this.wrapScreenUI);
        if (Viewer.zSpaceControls) {
            this.initZSpaceEvents();
            Viewer.zSpaceControls.off('buttonLeftUp');
            Viewer.zSpaceControls.off('buttonLeftDown');
            Viewer.zSpaceControls.off('buttonRightUp');
            Viewer.zSpaceControls.off('buttonRightDown');
        }
    }
    initZSpaceEvents() {
        this.zSpacePickingController = new ZSpacePickingController({
            minPickingDistance: 0.1,
            maxPickingDistance: 100,
            controllersQuantity: 1,
        }, Viewer.zSpaceControls);
        const raycaster = new Raycaster();
        // @ts-ignore
        this.zSpacePickingController.stylusController.addStylus();
        // @ts-ignore
        this.zSpacePickingController.stylusController.line.visible = false;
        // @ts-ignore
        this.zSpacePickingController.stylusController.line.raycast = () => { };
        Viewer.zSpaceControls.on('move', (event) => {
            const direction = new Vector3(0, 0, -1).applyQuaternion(event.quaternion);
            raycaster.ray.set(event.startPos, direction);
            const intersectScene = raycaster.intersectObjects(Viewer.scene.children, true)[0];
            // @ts-ignore
            this.zSpacePickingController.stylusController.setTransformation(event.startPos, event.quaternion);
            if (intersectScene) {
                // @ts-ignore
                this.zSpacePickingController.stylusController.setLength(intersectScene.distance);
                // @ts-ignore
                this.zSpacePickingController.stylusController.line.geometry.verticesNeedUpdate = true;
            }
        });
        Viewer.on('goToZSpace', () => {
            // @ts-ignore
            // document.querySelector('#threeJS + button').blur();
            Viewer.hemisphereLight.intensity = 0.45;
            Viewer.pointerController.raycastEnable = false;
            // @ts-ignore
            this.zSpacePickingController.stylusController.line.visible = true;
        });
        Viewer.on('goFromZSpace', () => {
            // @ts-ignore
            // document.querySelector('#threeJS + button').blur();
            Viewer.hemisphereLight.intensity = 0.7;
            Viewer.pointerController.raycastEnable = true;
            // @ts-ignore
            this.zSpacePickingController.stylusController.line.visible = false;
        });
        const zSpaceBtn = document.querySelector('#threeJS + button');
        if (zSpaceBtn && zSpaceBtn.innerText.toLowerCase().includes('zspace')) {
            zSpaceBtn.classList.add('zspace-mode-button');
            // @ts-ignore
            zSpaceBtn.addEventListener('focus', (event) => event.target.blur());
        }
    }
    initMainTheme() {
        const main = ResourcesManager.getAudioManger().getAudio('main_theme');
        main.loop = true;
        main.volume = 0.3;
        main.play();
    }
}
